export default class UIComponent {
  constructor() { }
  /**
   * 追加节点
   * @param {string} parentId 节点的class或id
   * @param {dom} child 要追加的节点
   */
  appendChild(className, child) {
    const parent = document.querySelector(`${className}`);
    parent.appendChild(child)
  }
}